import React from 'react';
import { badge, cn } from './uiTheme';

const VARIANTS = {
  default: badge.default,
  purple: badge.purple,
  teal: badge.teal,
  success: badge.success,
  warning: badge.warning,
  error: badge.error,
};

/**
 * Status / tag pill for the dark theme.
 */
export function Badge({ variant = 'default', className = '', children, ...props }: any) {
  return (
    <span
      className={cn('inline-flex items-center', VARIANTS[variant] || VARIANTS.default, className)}
      {...props}
    >
      {children}
    </span>
  );
}

export default Badge;
